<template>
  <div class="piechar-cla">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      style="width: 230px; height:200px;"
    >
      <defs>
        <linearGradient id="orange_red" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" style="stop-color:#327AFC;stop-opacity:0.8" />
          <stop offset="100%" style="stop-color:#68FFD3;stop-opacity:0.8" />
        </linearGradient>
        <g id="waiPie">
          <path d="M 30 190 A 110 110 0 1 1 200 190"></path>
        </g>

        <g id="neiPie">
          <path d="M 60 180 A 80 80 0 1 1 170 180"></path>
        </g>
      </defs>
      <g x="0" y="0">
        <use class="path1" stroke-dasharray="8,4" xlink:href="#waiPie" />
        <use class="path2" stroke-dasharray="8,400" xlink:href="#waiPie" />
        <use class="path3" xlink:href="#neiPie" />
        <use class="path4" xlink:href="#neiPie" />
        <path
          class="path5"
          ref="path2"
          stroke="url(#orange_red)"
          :style="{ strokeDashoffset: strokeDashoffset + 'px' }"
          d="M 60 180 A 80 80 0 1 1 170 180"
        ></path>
      </g>
    </svg>
    <div class="text-cla text1-cla" fill="#c9d3f5">{{ dealNumber(count) }}</div>
    <div class="text-cla text2-cla" fill="#ffffff">
      {{ (value / count) * 100 }}%
    </div>
    <div class="text-cla text3-cla" fill="#ffffff">
      {{ title }}
    </div>
  </div>
</template>

<script>
import { number } from 'echarts'
import { dealNumber } from '@/utils/utils.js'
export default {
  data() {
    return {
      pathLen: 0
    }
  },
  props: {
    count: {
      type: number,
      default: 100
    },
    value: {
      type: number,
      default: 50
    },
    title: {
      type: String,
      default: '设备活跃数'
    }
  },
  computed: {
    strokeDashoffset() {
      return 1000 - (this.value * this.pathLen) / this.count
    }
  },
  mounted() {
    var path2 = this.$refs.path2
    this.pathLen = path2.getTotalLength()
  },
  methods: {
    dealNumber(number) {
      return dealNumber(number)
    }
  }
}
</script>

<style scoped lang="less">
.piechar-cla {
  position: relative;
}

@keyframes dash {
  from {
    stroke-dashoffset: 1000;
  }
  to {
    stroke-dashoffset: 0;
  }
}

.path1 {
  fill: none;
  stroke: rgba(255, 255, 255, 0.5);
  stroke-width: 2;
}

.path2 {
  fill: none;
  stroke: #62f0d8;
  stroke-width: 2;
  animation: dash 15s linear infinite;
}

.path3 {
  fill: none;
  stroke: #ffffff;
  stroke-width: 30;
}

.path4 {
  fill: none;
  stroke: rgba(28, 55, 93, 0.8);
  stroke-width: 28;
}

.path5 {
  fill: none;
  stroke-width: 30;
  stroke-dasharray: 1000px;
  stroke-dashoffset: 1000px;
  transition: all 1s linear;
}

.text-cla {
  width: 100%;
  text-align: center;
  position: absolute;
  font-weight: 400;
}
.text1-cla {
  top: 90px;
  font-size: 26px;
  font-family: PangMenZhengDao;
  font-weight: 600;
  color: #c9d3f5;
}

.text2-cla {
  top: 130px;
  font-size: 16px;
  font-family: PangMenZhengDao;
  color: #ffffff;
}

.text3-cla {
  top: 160px;
  font-size: 14px;
  font-family: Source Han Sans CN;
  color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/modules/dashboard/pie/pieChar.vue